import React, { useEffect, useState, useContext } from 'react';
import api from '../utils/api'; 
import './styles/Kidola.css';
import AuthContext from '../context/AuthContext';
import { useNavigate } from 'react-router-dom'; 

const CreateExtraTimePage = () => {
    const { user } = useContext(AuthContext);
    const [typeList, setTypeList] = useState([]);
    const [teacher, setTeacher] = useState(null);
    const [selectedType, setSelectedType] = useState('');
    const [extraTimeDate, setExtraTimeDate] = useState(new Date().toISOString().split('T')[0]); // Set default to today
    const [description, setDescription] = useState('');
    const [amount, setAmount] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [timeList, setTimeList] = useState([]);
    const [workHourTo, setWorkHourTo] = useState(null);
    const [outingTypeId, setOutingTypeId] = useState(null);
    const [toodlerTypeId, setToodlerTypeId] = useState(null);
    const [transportTypeId, setTransportTypeId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch data for extra time types and teachers when page loads
        api.get('/utils/getExtraTimeTypeList')
          .then(response => setTypeList(response.data.data.typeList))
          .catch(error => console.error('Error fetching type list:', error));

    
        api.post('/teacher/extratime/getTeacher', 
            {
                data: {
                    username: user.username
                }
            })
          .then(response => {
              const teacherData = response.data.data;
              setTeacher(teacherData);
              setWorkHourTo(teacherData.work_hour_to); // Set work_hour_to from teacher data
          })
          .catch(error => console.error('Error fetching teacher list:', error));
    }, [user.username]);

    useEffect(() => {
        const fieldTripType = typeList.find(type => type.Type.type_name === 'FIELD TRIP');
        const toodlerType = typeList.find(type => type.Type.type_name === 'TOODLER');
        const transportType = typeList.find(type => type.Type.type_name === 'TRANSPORT');
        
        if (fieldTripType) {
            setOutingTypeId(fieldTripType.type_id); // Store FIELD TRIP type ID
        } 
        if (toodlerType) {
            setToodlerTypeId(toodlerType.type_id); // Store TODDLER type ID
        }
        if (transportType) {
            setTransportTypeId(transportType.type_id); // Store TODDLER type ID
        }
    }, [typeList]);
    
    useEffect(() => {
        if(selectedType == transportTypeId){
            return;
        }
        const tanggal = extraTimeDate.split('-')[2];
        if (workHourTo !== null && extraTimeDate && selectedType) {
            const dayOfWeek = new Date(extraTimeDate).getDay();
            if (dayOfWeek === 0) { 
                setTimeList([]); 
                return;
            }
            let times = [];
            if (selectedType == outingTypeId || selectedType == toodlerTypeId) { 
                
                for (let hour = 7; hour <= 17; hour++) {
                    if (hour !== 12) {
                        times.push(hour);
                    }
                }
            } else {
                if (tanggal > 28){
                    for (let hour = 8; hour <= 17; hour++) {
                        if (hour !== 12) {
                            times.push(hour);
                        }
                    }
                } else {
                    if ( workHourTo == 12 ) {
                        for (let hour = workHourTo + 1; hour <= 17; hour++) {
                            if (hour !== 12) {
                                times.push(hour);
                            }
                        }
                    } else {
                        for (let hour = workHourTo ; hour <= 17; hour++) {
                            if (hour !== 12) {
                                times.push(hour);
                            }
                        }
                    }
                }
            }
            setTimeList(times);
        }
    }, [workHourTo, extraTimeDate, selectedType, outingTypeId]);

    const handleCheckboxChange = (time) => {
        setSelectedItems((prevSelected) => {
            if (prevSelected.includes(time)) {
                return prevSelected.filter((t) => t !== time); 
            } else {
                return [...prevSelected, time]; 
            }
        });
    };

    const handleSubmit = () => {
        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }
        
        const timeListToSend = selectedItems.map(time => ({ time }));
        const extraTimeData = {
            extra_time_date: extraTimeDate,
            extra_time_type_id: selectedType,
            teacher_id: teacher.teacher_id, // Assuming teacher_id is available
            description: description,
            amount: amount? amount : timeListToSend.length,
            timeList: timeListToSend
        };
        
        const requestBody = { data: { extraTimeData } };
        console.log(requestBody);
        api.post('/teacher/extratime/create', requestBody)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
            })
            .catch(error => {
                console.error('Error adding/updating teacher:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Create Extra Time</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Extra Time Type</label>
                                    </td>
                                    <td>
                                        <select 
                                            name="type_id" 
                                            value={selectedType} 
                                            onChange={e => {
                                                setSelectedType(e.target.value);
                                                setSelectedItems([]); // Reset selected items when type changes
                                            }}
                                        >
                                            <option value="">Select Extra Time Type</option>
                                            {typeList.map(type => (
                                                <option key={type.type_id} value={type.type_id}>{type.name}</option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Extra Time Date</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="date" 
                                            name="extra_time_date" 
                                            value={extraTimeDate} 
                                            onChange={e => setExtraTimeDate(e.target.value)} 
                                        />
                                    </td>
                                </tr>
                                {selectedType == transportTypeId &&
                                <tr>
                                    <td>
                                        <label>Amount</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="number" 
                                            name="amount" 
                                            value={amount} 
                                            onChange={e => setAmount(e.target.value)} 
                                        />
                                    </td>
                                </tr>
                                }
                                <tr>
                                    <td>
                                        <label>Description</label>
                                    </td>
                                    <td>
                                        <textarea 
                                            name="description" 
                                            value={description} 
                                            onChange={e => setDescription(e.target.value)} 
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    {selectedType != transportTypeId &&
                    <div className="inventory-list">
                        <table>
                            <thead>
                                <tr>
                                    <th className="no-column">Select</th>
                                    <th>Start Time</th>
                                    <th>Finish Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {timeList.map((time, index) => (
                                <tr key={time}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedItems.includes(time)}
                                            onChange={() => handleCheckboxChange(time)}
                                        />
                                    </td>
                                    <td>{time}.00</td>
                                    <td>{time+1}.00</td>
                                </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    }
                    <div className="search-container">
                        <button onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateExtraTimePage;
